import React, { useState } from "react";
import Spinner from "../../assets/icons/Spinner";
import backend from "../../backend/backend";
import Message from "../../i18n/Message";
import ModalDialog from "./ModalDialog";
import UpgradeDialogHost from "./subscription/UpgradeDialogHost";

import "./FastspringIntegration.scss";

window.isCreditsOrder = false;

window.onPaymentFinished = (orderRef) => {
  if (orderRef && orderRef.id) {
    console.log("order: ", orderRef);
    window.fastspring.builder.reset();
    //window.fsShowDialog();
    const prom = window.isCreditsOrder
      ? backend.processCreditsOrder
      : backend.processOrder;

    prom(orderRef.id, orderRef.reference)
      .then(() => {
        //window.fsHideDialog();
        window.location.reload();
      })
      .catch((err) => {
        console.log("Failed to process the order: ", orderRef, err);
        window.fsHideDialog && window.fsHideDialog();
        window.isCreditsOrder = false;
        //TODO: toast
      });
    /*
         var template = "<@spring.message "page.pricing.thank_you" />";
         
         var text = template.replace(/order_number/g, orderRef.reference);         
         $('#order_thanks').html(text);
         $('#order_thanks').show();
         */
  } else {
    window.fsShowError();
    //canceled checkout
    //console.log("no order ID");
  }
};

// FastSpring Store Builder Library error callback (wired via data-error-callback in
// public/index.html). Fires when the builder can't start/finalize checkout -- e.g. a
// product/variation that doesn't exist in the storefront returns "variation-not-found".
// Without this the SBL only logs to the console and the user sees nothing.
window.onFastspringError = (err) => {
  console.warn("[FastSpring] builder error: ", err);
  window.gAiknLastError = err;
  window.fsShowError && window.fsShowError("payment_start_failed");
};

window.showPaymentWindow = (user, productPath) => {
  //console.log("User: ", user);
  console.log("productPath: ", productPath);
  var productList = [{ quantity: 1, path: productPath }];
  var session = { products: productList, reset: true, checkout: true };
  window.gAiknUser = user;
  window.gAiknProd = productPath;
  window.fastspring.builder.recognize({
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
  });
  window.fastspring.builder.push(session);
};

const FastspringIntegration = () => {
  const [show, setShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMsgId, setErrorMsgId] = useState("payment_problem");

  window.fsShowDialog = () => setShow(true);
  window.fsHideDialog = () => setShow(false);
  window.fsShowError = (msgId) => {
    setErrorMsgId(msgId || "payment_problem");
    setShowError(true);
  };
  // Only offer a retry when there is a product to retry with (a start-failure with no
  // resolvable product path can't be retried by re-pushing the same session).
  const canRetry = !!window.gAiknProd;
  return (
    <>
      <UpgradeDialogHost />
      {show && (
        <ModalDialog onClose={() => setShow(false)}>
          <div className="spinner_container">
            <Spinner />
          </div>
        </ModalDialog>
      )}
      {showError && (
        <ModalDialog onClose={() => setShowError(false)}>
          <div className="fs_error_text error_alert mtop-24">
            <Message id={errorMsgId} />
          </div>
          {canRetry && (
            <div className="flex-center">
              <button
                onClick={() => {
                  setShowError(false);
                  window.showPaymentWindow(window.gAiknUser, window.gAiknProd);
                }}
                className="btn btn-dark"
              >
                <Message id="add_card" />
              </button>
            </div>
          )}
        </ModalDialog>
      )}
    </>
  );
};

export default FastspringIntegration;
